import { BaseEntity } from 'yt-ng-framework';

export class WesternUnion extends BaseEntity {
    constructor(){
        super();
    }

    // OrgJedID: number=null;
    Datum: Date=null;
    UkupnoIsplataRsd: number=0;
    UkupnoIsplataEur: number=0;
    UkupnoUplata: number=0;
    UkupnoProvizija: number=0;

    Deserialize(input: any){
        this.ID = input.ID;
        // this.OrgJedID = input.OrgJedID;
        this.Datum = input.Datum;
        this.UkupnoUplata = input.UkupnoUplata;
        this.UkupnoIsplataRsd = input.UkupnoIsplataRsd;
        this.UkupnoIsplataEur = input.UkupnoIsplataEur;
        this.UkupnoProvizija =input.UkupnoProvizija;

        return this;
    }

    Serialize(input: WesternUnion){
        return input;
    }
}